import AddOnAdjuster from './add-on-adjuster';

class DomAdjuster {
	static adjustAtcAreaContent(selectedOption, fulfillmentDetails, partialReload=false){
			if(!fulfillmentDetails.showNotifyBox){
				AddOnAdjuster.moveAddOns(fulfillmentDetails);
			}
			//if add to cart button not showing
			if(fulfillmentDetails.showNotifyBox || fulfillmentDetails.allTilesDisabled){
				this.toggleHdppOption(false);
			}
			if(fulfillmentDetails.showNotifyBox){
				this.toggleProReferral();
			}
			if(fulfillmentDetails.discontinuedItem){
				moveTrendingItems();
			}
			
			moveSubscriptions(selectedOption, fulfillmentDetails);
			try{
		      hideInStoreAssembly();
			  moveAisleBay();
		      moveQuantityButtons();
		      reStyleQuantity();
		      moveEmergencyMsg();
			  movePaintPriceSection();
			  moveBogo();
			  moveMSB();
			  moveOverview();
			  moveQuoteSkus();
			  supressNeedMoreLegacyBuyBoxToolTip();
		    }catch(e){
		      console.error(e);
		    }
		    if(partialReload){
				setTimeout(()=>{
					this.reAdjustPaintSwatches();
					// AddOnAdjuster.reAdjustExpertInHome();
				}, 1000);
		    }
	}

	static hideQuantityButtons(){
		try{
			const bbf = document.querySelector('.buybox__quantity-flex');
			if(bbf){
				bbf.style.display = "none";
			}
		}catch(e){
			console.error(e);
		}
	}

	static toggleAssemblyInstallation(selectedFfm){
		try{
			if(selectedFfm==="STH"){
				AddOnAdjuster.enableDisableInstallationAddOn(true);
			}else{
				AddOnAdjuster.enableDisableInstallationAddOn(false);
			}
		}catch(e){
			console.error(e);
		}
	}

	static toggleProReferral(){
		try{
			let proReferral = document.querySelector('#buyBox-pro-referral');
			if(proReferral){
				proReferral.classList.add('u--hide');
			}
		}catch(e){
			console.error(e);
		}
	}

	static toggleSubscription(selectedFfm){
		try{
			if(selectedFfm==="STH"){
				hideShowSubscription(true);
			}else{
				hideShowSubscription(false);
				let atcButton = document.querySelector('#atc_pickItUp');
				if(atcButton){
					let buttonContent = atcButton.querySelector('.bttn__content');
					if(buttonContent) {
						buttonContent.innerHTML = "Add to Cart";
					}
				}
			}
		}catch(e){
			console.error(e);
		}
	}

	static toggleHdppOption(value) {
		try {
			let hdpp = document.querySelector('#buyBox-hdpp');
			if(hdpp){
				if (value) {
					hdpp.classList.remove('u--hide');
				} else {
					hdpp.classList.add('u--hide');
				}
			}
		}catch(e){
			console.error(e);
		}
	}

	static reAdjustPaintSwatches(){
		try{
			if(document && document.querySelector){
				const superSkuExist = document.querySelector('.buybox__super-sku');
				const superSkuInlineExist = document.querySelector('.super-sku__inline');
				if(superSkuExist || superSkuInlineExist){
					const buyBeltPaintSection = document.querySelector('.align-bottom');
					buyBeltPaintSection.style.marginTop = 0;
					const atcArea = document.querySelector('.buybelt.atc-area');
					const addOnContainer = document.querySelector('#add-on__container');
					if(atcArea && buyBeltPaintSection){
						atcArea.prepend(buyBeltPaintSection);
						movePaintPriceSection();
						addOnContainer && atcArea.insertAdjacentElement('beforebegin', addOnContainer);
						reStyleQuantity();
					}
				}
			}
		}catch(e){
			console.error(e);
		}
	}

	static uncheckInstallation(){
		try{
		 const install = document.querySelector("#attach-labor__checkbox");
		 if(install && install.checked){
		 	install.checked=false;
			window.PIP_HOOKS.pip.customer.attachLabor.isOptedIn = false;
		 }
		}catch(e){
			console.error(e);
		}
	}
}

function supressNeedMoreLegacyBuyBoxToolTip() {
	try{
		const buyBox = document.getElementById('buybox__quantity__input');
		if(buyBox){
			buyBox.onclick = function supress() { 
				const needMoreTooltip = document.querySelector('.Tooltip--need-more-products');
				//check innerText to make sure to select the legacy tooltip, not the new one
				if(needMoreTooltip && needMoreTooltip.innerText && needMoreTooltip.innerText.includes("Your store only has")){
					needMoreTooltip.style.display = "none";
				}
			}
		}
	}catch(e){
		console.error(e);
	}
}

function moveQuoteSkus() {
	try {
		const quote = document.querySelector('#request-a-quote-btn');
		const bbNew = document.querySelector('#buybelt-wrapper-new');
		const addOnContainer = document.querySelector('#add-on__container');
		if(quote && bbNew){
			bbNew.insertAdjacentElement('beforebegin', addOnContainer);
		}

	}
	catch(e){
		console.error(e);
	}
}

function moveQuantityButtons() {
	try{
		const bb = document.querySelector('.buybelt');
		const atc = document.querySelector('.atc-button');
		const icOpen = document.querySelector('#icInfoTooltipOpener');
		const bbf = document.querySelector('.buybox__quantity-flex');
		if(atc && atc.parentNode && bbf){
			atc.parentNode.insertBefore(bbf, atc);
			bbf.style.display = "block";
		}
		const icbox = document.querySelector('#placeToolTip');
		if(icbox){
			icbox.insertAdjacentElement('afterend', icOpen);
		}
	}catch(e){
		console.error(e);
	}
}

function moveEmergencyMsg(){
	try{
		const buyBox = document.querySelector('#buybox__quantity');
		const emMsg = document.querySelector('.quantity-emergency-msg');
		const atc = document.querySelector('.atc-button');
		if(emMsg){
			buyBox && buyBox.insertAdjacentElement('beforebegin', emMsg);
		}
		if(emMsg && atc) {
			atc.style.marginTop = '16px';
		}
	}catch(e){
		console.error(e);
	}
}

function movePaintPriceSection(){
	try{
		if(document && document.querySelector){
			const atcArea = document.querySelector('.buybelt.atc-area');
			if(atcArea){
				const paintBuyBoxQundity = atcArea.querySelector('#buybox__quantity');
				const paintbuyBoxPrice = atcArea.querySelector('.buybox__price');
				const parentQuandity = atcArea.querySelector('.buybox__quantity-flex');
				if(paintbuyBoxPrice){
					paintBuyBoxQundity && paintBuyBoxQundity.insertAdjacentElement('afterend', paintbuyBoxPrice);
					atcArea.style.flexWrap = "wrap";
					paintbuyBoxPrice.style.width = "100%";
					parentQuandity.style.display = "block";
					const paintbuyBoxPriceCopy = parentQuandity.removeChild(paintbuyBoxPrice);
					if(!isIe11()){
						atcArea.prepend(paintbuyBoxPriceCopy);	
					}else{
						atcArea.parentNode.insertBefore(paintbuyBoxPriceCopy, atcArea);
					}
				}
			}
		}
	}catch(e){
		console.error(e);
	}
}

export function moveAisleBay() {
	try{
		const  aisleBay = document.querySelector('.aisle-bay__wrapper');
		const sharingContainer = document.querySelector('#sharingContainer');
		const mediaSection = document.querySelector('#mediaPlayer');
		if (mediaSection && sharingContainer && aisleBay) {
			sharingContainer.align = 'center';
			if (window.innerWidth < 600) {
				const mobileStore = document.querySelector('#store-availability');
				if(mobileStore){
					const storeMapContainer = mobileStore.querySelector('.store-availability__inventory');
					if(storeMapContainer){
						const storeMap = storeMapContainer.querySelector('a');
						const contentNode = storeMap.querySelector('span');
						const iconNode =  document.createElement("span");
						iconNode.classList.add('pinIcon');
						iconNode.classList.add('pip-icons');
						iconNode.innerText = 'pinIcon';
						aisleBay && aisleBay.append(storeMap);
						storeMap.removeChild(contentNode);
						storeMap.prepend(iconNode);
						storeMap.style.display = 'inline-block'
						storeMap.style.display = 'inline-block'
						sharingContainer.prepend(storeMap);
						const mobileView = mediaSection.insertAdjacentElement('afterend', sharingContainer);
						aisleBay && mobileView.insertAdjacentElement('beforebegin', aisleBay);
						mobileStore.style.display = 'none';
						if(!isIe11()){
							aisleBay.classList.remove('aisle-bay__wrapper--hidden');
						}else{
							aisleBay.className = aisleBay.className.replace("aisle-bay__wrapper--hidden", "") 
						}
						
					}
				}
			} else {
				const desktopView = mediaSection.insertAdjacentElement('afterend', sharingContainer);
				aisleBay && desktopView.insertAdjacentElement('beforebegin', aisleBay);
				if(!isIe11()){
					aisleBay.classList.remove('aisle-bay__wrapper--hidden');
				}else{
					aisleBay.className = aisleBay.className.replace("aisle-bay__wrapper--hidden", "") 
				}
			}
		}
	} catch (e) {
		console.error(e);
	}
}

function hideInStoreAssembly(){
	const isa = document.querySelector('#buybox__in-store-assembly');
	if(isa){
		isa.style.display = "none";
	}
}

function reStyleQuantity(){
	const quantityLabel = document.querySelector('[for=buybox__quantity__input]');
	const quantityWrapper = document.querySelector('.quantity-section-wrapper');
	if(quantityLabel && quantityWrapper){
	  quantityLabel.style.display = "none";
	  //quantityWrapper.classList.remove("quantity-section-wrapper");
	}
}

// function moveAddOns(){
// 	const ac = document.querySelector('#add-on__container');
// 	let atc = document.querySelector('.add-ons__wrapper');
// 	let dualPath = document.querySelector('#dual-path__checkbox');
// 	if(!dualPath){
// 		if(ac && atc){
// 			atc.appendChild(ac);
// 			enableDisableInstallationAddOn(false);
// 		}
// 	}
// }

function moveSubscriptions(selectedOption, fulfillmentDetails){
	try{
		const subscribe = document.querySelector('.subscribe-and-save');
		if(fulfillmentDetails.isSubscriptionEligible &&
			!fulfillmentDetails.isOosAtOnline)
		{
			let wrapper = document.querySelector('.subscription__wrapper');
			if(subscribe){
				if(wrapper){
					wrapper.appendChild(subscribe);
					if(selectedOption!=="STH"){
						hideShowSubscription(false);
					}
				}else{
					subscribe.style.display = "none";
				}
			}
		}else{
			if(subscribe){
				subscribe.remove();
			}
		}
	}catch(e){
		console.error(e);
	}

}



function hideShowSubscription(show=false){
	try{
		const subscribe = document.querySelector('.subscribe-and-save');
		if(subscribe){
			if(show){
				subscribe.classList.remove("u--hide");
			}else{
				let optOut = document.querySelector('#subscribe-and-save-options__opt-out');
				if(optOut){
					optOut.click();
				}
				subscribe.classList.add("u--hide");
			}
		}
	}catch(e){
		console.error(e);
	}
}

function moveOverview() {
	try{
		const overview = document.querySelector('.buybox__description');
		const bbNew = document.querySelector('#buybelt-wrapper-new');
		if(overview && bbNew){
			bbNew.parentNode.insertBefore(overview, bbNew);
		}
	}catch(e){
		console.error(e);
	}
}

function moveBogo() {
	try{
		const bogo = document.querySelector('#buy-one-get-one');
		const bbNew = document.querySelector('#buybelt-wrapper-new');
		if(bogo && bbNew){
			setTimeout(()=>{
				bbNew.parentNode.insertBefore(bogo, bbNew);
			}, 250);
			
		}
	}catch(e){
		console.error(e);
	}
}

function moveMSB() {
	try{
		const msb = document.querySelector('#msb-wrapper');
		const bbNew = document.querySelector('#buybelt-wrapper-new');
		if(msb && bbNew){
			setTimeout(()=>{
				bbNew.parentNode.insertBefore(msb, bbNew);
			}, 250);			
		}
	}catch(e){
		console.error(e);
	}
}

function moveTrendingItems() {
	try{
		const certona = document.querySelector('#certona_recommendations');
		const description = document.querySelector('#product_description');
		if(certona && description){
			description.parentNode.insertBefore(certona, description);
		}
	}catch(e){
		console.error(e);
	}
}

function isIe11(){
	try{
	  return (!!window.MSInputMethodContext && !!document.documentMode);
	}catch(e){
	  console.error(e);
	}
}

export default DomAdjuster;
